import React, { useState, useEffect } from 'react';
import './Products.css';
import { useNavigate } from 'react-router-dom';
import { getProductsByUserId } from '../../api/productApi';
import { getMe } from '../../api/loginAPI';

import certPreview from '../../assests/Preview.png';
import tokenisation from '../../assests/tokenisation.png';

const staticProducts = [
  {
    id: 'digital-certificate',
    title: 'Digital Certificate',
    image: certPreview,
    description: `The Digital Certificate is a verifiable credential that confirms a user's identity, affiliation, or achievement.`,
    features: [
      'Secure & Verifiable',
      'Globally Recognized',
      'Eco-Friendly',
    ],
    useCases: [
      'Academic certificates',
      'Employment verification',
      'Membership proof',
    ],
  },
  {
    id: 'earthid-wallet',
    title: 'EarthID Wallet',
    image: tokenisation,
    description: `Store and manage your self-sovereign identity credentials securely and privately.`,
    features: [
      'Decentralized Identity',
      'User-controlled Sharing',
      'Interoperable Standards',
    ],
    useCases: [
      'Digital identity wallet',
      'KYC/AML integration',
      'SSO for dApps',
    ],
  },
];

export default function Products() {
     const navigate = useNavigate();
     
  const [userProducts, setUserProducts] = useState([]);
  const [user, setUser] = useState(null);

  useEffect(() => {
    async function fetchUser() {
      const userData = await getMe();
      setUser(userData);
    }
    fetchUser();
  }, []);

  useEffect(() => {
    if (user) {
      getProductsByUserId(user.Id).then((res) => {
        setUserProducts(res || []);
      });
    }
  }, [user]);

  const mergedProducts = userProducts.map((userProd) => {
    const matched = staticProducts.find((p) => p.title === userProd.productName);
    return {
      id: userProd.productId,
      title: userProd.productName,
      image: matched?.image || '',
      description: matched?.description || userProd.productDescription,
      features: matched?.features || [],
      useCases: matched?.useCases || [],
    };
  });

  return (
    <div className="page products-layout">
      <h2 className="products-title">Explore Our Products</h2>
      <div className="products-grid">
        {mergedProducts.map((prod) => (
          <div  key={prod.id} className="product-card modern-card">
            <div className="product-image">
              <img src={prod.image} alt={`${prod.title} Preview`} />
            </div>
            <h3 className="product-name">{prod.title}</h3>
            <p className="product-description">{prod.description}</p>
            <button
      onClick={() => navigate(`/products/${prod.id}`)}
      className="view-btn"
    >
      View Details
    </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export { staticProducts };
